export default __webpack_public_path__ + "static/media/logo-ppdb-2024.81977b54.png";